'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _some2 = require('./internal/_some');

var _some3 = _interopRequireDefault(_some2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns `true` if **any** items in `subject` match `predicate`.
 *
 * @example
 * const anyBlue = some(v => v === 'blue');
 *
 * anyBlue(List.of('blue', 'red')) === true;
 * anyBlue(List.of('red', 'red')) === true;
 *
 * @param  {Function} predicate returns `true` if item is a match.
 * @param  {Iterable} subject
 * @return {bool}
 */
exports.default = (0, _curry2.default)(_some3.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/some.js
// module id = 373
// module chunks = 2 3